module.exports = __webpack_public_path__ + "static/media/michele-silva.398cc2f1.png";